import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "fill"]
const _hoisted_2 = { "clip-path": "url(#clip0_11969_50634)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_11969_50634" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "15.5833",
      height: "12",
      fill: "white",
      transform: "translate(0.862305 0.5)"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'barChartIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 17,
  },
  height: {
    type: Number as PropType<number>,
    default: 13,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: __props.color,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M4.52897 4.5H1.8623C1.59709 4.5 1.34273 4.60536 1.1552 4.79289C0.967662 4.98043 0.862305 5.23478 0.862305 5.5L0.862305 11.5C0.862305 11.7652 0.967662 12.0196 1.1552 12.2071C1.34273 12.3946 1.59709 12.5 1.8623 12.5H4.52897C4.61738 12.5 4.70216 12.4649 4.76467 12.4024C4.82719 12.3399 4.8623 12.2551 4.8623 12.1667V4.83333C4.8623 4.74493 4.82719 4.66014 4.76467 4.59763C4.70216 4.53512 4.61738 4.5 4.52897 4.5Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M7.12619 0.5H10.1817C10.3843 0.5 10.5786 0.599812 10.7219 0.777478C10.8652 0.955144 10.9456 1.19611 10.9456 1.44737V12.1842C10.9456 12.268 10.9188 12.3483 10.8711 12.4075C10.8233 12.4667 10.7585 12.5 10.691 12.5H6.61693C6.5494 12.5 6.48464 12.4667 6.43688 12.4075C6.38913 12.3483 6.3623 12.268 6.3623 12.1842V1.44737C6.3623 1.19611 6.44279 0.955144 6.58604 0.777478C6.7293 0.599812 6.9236 0.5 7.12619 0.5Z",
        fill: __props.color
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M15.4458 7.5H12.7791C12.6907 7.5 12.6059 7.53292 12.5434 7.59153C12.4809 7.65013 12.4458 7.72962 12.4458 7.8125V12.1875C12.4458 12.2704 12.4809 12.3499 12.5434 12.4085C12.6059 12.4671 12.6907 12.5 12.7791 12.5H15.4458C15.711 12.5 15.9654 12.4012 16.1529 12.2254C16.3404 12.0496 16.4458 11.8111 16.4458 11.5625V8.4375C16.4458 8.18886 16.3404 7.9504 16.1529 7.77459C15.9654 7.59877 15.711 7.5 15.4458 7.5Z",
        fill: __props.color
      }, null, 8, _hoisted_5)
    ]),
    _hoisted_6
  ], 8, _hoisted_1))
}
}

})